import {httpPost} from "./http-functions";
import config from "../config";
import {DeviceActivationRequest, SubscriptionsExpirationRequest, UsageStatsRequest} from "../models/report.model";
import {toLocaleJsonDate} from "../utils/function-util";

interface BlobFile {
    blob: Blob,
    filename: string
}

export const downloadOrganizationUsageStats = async (request: UsageStatsRequest): Promise<any> => {
    const resp = await httpPost(`${config.api}/reports/usage-stats`, {
        ...request,
        startDate: toLocaleJsonDate(request.startDate),
        endDate: toLocaleJsonDate(request.endDate || request.startDate)
    }, {
        responseType: 'blob'
    });

    let headerLine = resp.headers['content-disposition'];
    const filenameReg = /filename="(.*)"/;
    const matches = headerLine?.match(filenameReg);
    const filename = Array.isArray(matches) && matches.length > 1 ? matches[1] : "stats.xlsx";

    return {
        blob: resp.data,
        filename
    }
};


export const downloadSubscriptionsExpiration = async (request: SubscriptionsExpirationRequest): Promise<any> => {
    const resp = await httpPost(`${config.api}/reports/subscriptions-expiration`, {
        ...request,
        startDate: toLocaleJsonDate(request.startDate),
        endDate: toLocaleJsonDate(request.endDate || request.startDate)
    }, {
        responseType: 'blob'
    });

    let headerLine = resp.headers['content-disposition'];
    const filenameReg = /filename="(.*)"/;
    const matches = headerLine?.match(filenameReg);
    const filename = Array.isArray(matches) && matches.length > 1 ? matches[1] : "report.xlsx";

    return {
        blob: resp.data,
        filename
    }
};

export const downloadDeviceActivation = async (request: DeviceActivationRequest): Promise<any> => {
    const resp = await httpPost(`${config.api}/reports/device-activation`, request, {responseType: 'blob'});

    let headerLine = resp.headers['content-disposition'];
    const filenameReg = /filename="(.*)"/;
    const matches = filenameReg.exec(headerLine);
    const filename = Array.isArray(matches) && matches.length > 1 ? matches[1] : "report.xlsx";

    return {
        blob: resp.data,
        filename
    };
};
